import * as actions from "../constants/actionTypes";

export const INITIAL_STATE = {
    singleMediaFeed: [],
    singleMediaLoader: true,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_SINGLE_MEDIA_DATA_SUCCESS:
            return {
                ...state,
                singleMediaFeed: action.payload.singleMediaFeed,
                singleMediaLoader: false,
            }
        case actions.RESET_SINGLE_MEDIA_DATA: {
            return {
                ...state,
                singleMediaFeed: [],
                singleMediaLoader: true,
            }
        }
        case actions.SEND_MEDIA_LIKE_FEEDBACK_SUCCESS: {
            const { interactionType } = action.payload;

            const { singleMediaFeed } = state;
            if (interactionType == "B") {
                singleMediaFeed.flagBookmarkedByMe = !singleMediaFeed.flagBookmarkedByMe;
            } else if (interactionType == "L") {
                singleMediaFeed.flagLikedByMe = !singleMediaFeed.flagLikedByMe;
            }
            return {
                ...state,
                singleMediaFeed: [...singleMediaFeed]
            }
        }
        case actions.GIVE_VOTE_SUCCESS_SINGLE_MEDIA: {
            const { singleMediaFeed } = state;
            singleMediaFeed.totalVotes += 1;
            singleMediaFeed.todaysVotes += 1;
            singleMediaFeed.votesByMe += 1;
            singleMediaFeed.isVotedByMe = true;

            return {
                ...state,
                singleMediaFeed: [...singleMediaFeed]
            }
        }

        case actions.UPDATE_SINGLE_MEDIA_VIEW_COUNT_SUCCESS: {
            let { singleMediaFeed } = state;
            singleMediaFeed.viewCount += 1;
            return {
                ...state,
                singleMediaFeed: { ...singleMediaFeed }
            }
        }
        default:
            return state;
    }
}


